import { useAuth } from "@/contexts/AuthContext";
import { MainLayout } from "@/components/layout/MainLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  Megaphone, Tag, Star, Gift, Bell, Link2, Bot, Send, Users, TrendingUp, BarChart3, Zap, LineChart as LineChartIcon
} from "lucide-react";
import { PixelsTab } from "@/components/marketing/PixelsTab";
import MarketingAnalyticsTab from "@/components/marketing/MarketingAnalyticsTab";
import { InfluencerTab } from "@/components/settings/InfluencerTab";
import { WhatsAppAnalyticsTab } from "@/components/marketing/WhatsAppAnalyticsTab";
import { LoyaltyTab } from "@/components/marketing/LoyaltyTab";
import { UpsellAnalyticsTab } from "@/components/marketing/UpsellAnalyticsTab";
import { CuponesTab } from "@/components/marketing/CuponesTab";
import { EvaluacionesTab } from "@/components/marketing/EvaluacionesTab";
import { PromocionesTab } from "@/components/marketing/PromocionesTab";
import { CashbacksTab } from "@/components/marketing/CashbacksTab";
import { NotificacionesPushTab } from "@/components/marketing/NotificacionesPushTab";
import { LinksTab } from "@/components/marketing/LinksTab";
import { EnviosMasaTab } from "@/components/marketing/EnviosMasaTab";
import { ChatbotTab } from "@/components/marketing/ChatbotTab";
import { VideoGenerationTab } from "@/components/marketing/VideoGenerationTab";
import MarketingGrowthContainer from "@/components/marketing/MarketingGrowthContainer";

const SectionLabel = ({ children }) => (
  <span className="w-full px-1 pt-2 pb-0.5 text-[9px] font-bold text-gray-400 uppercase tracking-widest border-t border-gray-200 first:border-0 first:pt-0">
    {children}
  </span>
);

export default function MarketingPage() {
  const { authAxios } = useAuth();

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl sm:text-4xl font-bold uppercase tracking-tight">Marketing</h1>
          <p className="text-muted-foreground mt-1">Herramientas para atraer y fidelizar clientes</p>
        </div>
        <Tabs defaultValue="upsell">
          <TabsList className="bg-secondary flex flex-wrap h-auto gap-1 p-1">
            <SectionLabel>Aquisição</SectionLabel>
            <TabsTrigger value="analytics" className="gap-1.5" data-testid="tab-analytics"><BarChart3 className="w-3.5 h-3.5" />Analytics</TabsTrigger>
            <TabsTrigger value="cupones" className="gap-1.5"><Tag className="w-3.5 h-3.5" />Cupones</TabsTrigger>
            <TabsTrigger value="promociones" className="gap-1.5"><Gift className="w-3.5 h-3.5" />Promociones</TabsTrigger>
            <TabsTrigger value="pixels" className="gap-1.5" data-testid="tab-pixels"><Zap className="w-3.5 h-3.5" />Pixels</TabsTrigger>
            <TabsTrigger value="influencers" className="gap-1.5" data-testid="tab-influencers"><Users className="w-3.5 h-3.5" />Influenciadores</TabsTrigger>
            <TabsTrigger value="links" className="gap-1.5"><Link2 className="w-3.5 h-3.5" />Links</TabsTrigger>
            <TabsTrigger value="video" className="gap-1.5" data-testid="tab-video">
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3" /></svg>
              Video IA
            </TabsTrigger>

            <SectionLabel>Retenção</SectionLabel>
            <TabsTrigger value="upsell" className="gap-1.5" data-testid="tab-upsell"><TrendingUp className="w-3.5 h-3.5" />Upsell</TabsTrigger>
            <TabsTrigger value="fidelidad" className="gap-1.5"><Star className="w-3.5 h-3.5" />Fidelidad</TabsTrigger>
            <TabsTrigger value="evaluaciones" className="gap-1.5"><Star className="w-3.5 h-3.5" />Evaluaciones</TabsTrigger>
            <TabsTrigger value="cashbacks" className="gap-1.5"><Gift className="w-3.5 h-3.5" />Cashbacks</TabsTrigger>
            <TabsTrigger value="push" className="gap-1.5"><Bell className="w-3.5 h-3.5" />Push</TabsTrigger>
            <TabsTrigger value="wa-analytics" className="gap-1.5"><BarChart3 className="w-3.5 h-3.5" />WhatsApp</TabsTrigger>

            <SectionLabel>Insights</SectionLabel>
            <TabsTrigger value="growth" className="gap-1.5"><TrendingUp className="w-3.5 h-3.5" />Growth</TabsTrigger>

            <SectionLabel>Automação</SectionLabel>
            <TabsTrigger value="chatbot" className="gap-1.5"><Bot className="w-3.5 h-3.5" />Chatbot</TabsTrigger>
            <TabsTrigger value="envios" className="gap-1.5"><Send className="w-3.5 h-3.5" />Envíos</TabsTrigger>
          </TabsList>

          <TabsContent value="upsell" className="mt-6"><UpsellAnalyticsTab /></TabsContent>
          <TabsContent value="analytics" className="mt-6"><MarketingAnalyticsTab /></TabsContent>
          <TabsContent value="cupones" className="mt-6"><CuponesTab /></TabsContent>
          <TabsContent value="fidelidad" className="mt-6"><LoyaltyTab /></TabsContent>
          <TabsContent value="wa-analytics" className="mt-6"><WhatsAppAnalyticsTab /></TabsContent>
          <TabsContent value="evaluaciones" className="mt-6"><EvaluacionesTab /></TabsContent>
          <TabsContent value="promociones" className="mt-6"><PromocionesTab /></TabsContent>
          <TabsContent value="cashbacks" className="mt-6"><CashbacksTab /></TabsContent>
          <TabsContent value="push" className="mt-6"><NotificacionesPushTab /></TabsContent>
          <TabsContent value="links" className="mt-6"><LinksTab /></TabsContent>
          <TabsContent value="influencers" className="mt-6"><InfluencerTab authAxios={authAxios} /></TabsContent>
          <TabsContent value="chatbot" className="mt-6"><ChatbotTab /></TabsContent>
          <TabsContent value="envios" className="mt-6"><EnviosMasaTab /></TabsContent>
          <TabsContent value="video" className="mt-6"><VideoGenerationTab /></TabsContent>
          <TabsContent value="pixels" className="mt-6"><PixelsTab /></TabsContent>
          <TabsContent value="growth" className="mt-6"><MarketingGrowthContainer authAxios={authAxios} showHeader={false} showPeriodSelector={true} /></TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
